import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import FaceDermalPiercingImage from '../../Assets/Piercing Services/face dermal piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function FaceDermalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Face Dermal Piercing UAE | 500 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Face Dermal Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Face Dermal Piercing 500 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={FaceDermalPiercingImage} alt="Face Dermal Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Face Dermal Piercing</h3>

          <p>
            Enhance your personal style with our professional face dermal piercing services in the UAE, available at a premium price of 500 AED. Face dermal piercing is a modern and stylish surface piercing that places a single piece of jewelry directly into the skin, creating the appearance of a small, elegant gem resting on the face. This unique and eye-catching piercing is perfect for individuals who want to add a distinctive flair to their look while maintaining a clean and sophisticated aesthetic. Whether placed on the cheekbone, near the eye, or along the jawline, face dermal piercing offers a versatile and customizable option that highlights your facial features beautifully.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each face dermal piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Dermal piercings require advanced skill and expertise, especially on the face, and our experienced specialists are trained to ensure proper depth, placement, and stability for long-lasting and aesthetically pleasing results while minimizing discomfort.
          </p>

          <p>
            Face dermal piercing is ideal for those who want a bold yet refined body modification that stands out in a subtle and elegant way. Its minimalist design allows it to blend seamlessly with your natural features while still making a strong visual impact. You can choose from a variety of jewelry styles, including crystals, metallic tops, or decorative designs, allowing you to personalize your look according to your preferences. Our specialists take the time to understand your style and guide you in selecting the best placement and jewelry option to suit your facial structure and aesthetic goals.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic dermal jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smoother healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that facial dermal piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for face dermal piercings, and we provide detailed instructions to help you maintain proper care during the healing period. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection, irritation, or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our face dermal piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive exceptional value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted face dermal piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a unique and stylish look effortlessly. Book your face dermal piercing appointment today and elevate your appearance with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Face Dermal Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default FaceDermalPiercing;